import { Component, computed, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IThankYouPageData } from '../../../models/IThankYouPageData';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { IThankYouPageLines } from '../../../models/IThankYouPageLines';
import { RouterModule } from '@angular/router';
import { ApiService } from '../../../services/api.service';


@Component({
  selector: 'app-zero-purchase-thankyou-page',
  imports: [ButtonModule, CommonModule, DialogModule, ReactiveFormsModule, RouterModule],
  templateUrl: './zero-purchase-thankyou-page.component.html',
  styleUrl: './zero-purchase-thankyou-page.component.scss'
})
export class ZeroPurchaseThankyouPageComponent implements OnInit {

  @Input() thankYouData?: IThankYouPageData;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  thankyouPageLine!: IThankYouPageLines[];
  total: number | null = null;

  private readonly apiService = inject(ApiService);
  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')


  ngOnInit(): void {


    if (this.thankYouData) {

      this.thankyouPageLine = this.thankYouData.lines
      this.total = this.getTotal();
    }

  }

  getTotal(): number {
    const linesTotal = this.thankyouPageLine.reduce((sum, item) => sum + item.value * (item.quantity ?? 1), 0);
    const fee = this.thankYouData?.fee ?? 0;

    return linesTotal + fee;
  }

}
